import { useAuthDataContext } from "components/auth";
import { getSourceThumbnail, getRefreshedSourceThumbnail } from "config/paths";

export default (sourceId, refreshed) => {
  const { token } = useAuthDataContext();
  return refreshed ? getRefreshedSourceThumbnail(sourceId, token) : getSourceThumbnail(sourceId, token);
};
